<template>
    <div>
        <div v-if="!isConnected && currentStep !== 4">
            <loading></loading>
            <modal type="error">
                <template v-slot:title>Connection lost</template>
                <template v-slot:buttons><a href="/" class="btn btn--block btn--secondary">Refresh</a></template>
            </modal>
        </div>
        <loading v-if="isConnected && currentStep === 1"></loading>
        <room-dashboard v-if="isConnected && currentStep == 2" :matches="matches" :room="room"></room-dashboard>
        <multiplayer v-if="isConnected && currentStep == 3" :knockout-game="true" :code="code"></multiplayer>
        <room-password v-if="isConnected && currentStep == 4" :code="code"></room-password>

        <modal ref="alertModal" type="error" show="false">
            <template v-slot:message>
                Initialization failed: room with code <b>{{ code }}</b> not found!
            </template>
        </modal>
    </div>
</template>

<script>
    import RoomDashboard from "./RoomDashboard";
    import api from "../../../api/knockoutGame";
    import Multiplayer from "../Multiplayer";
    import {mapState} from "vuex";
    import RoomPassword from "../partial/RoomPassword";

    export default {
        components: {RoomPassword, Multiplayer, RoomDashboard },
        props: {
            code: {
                required: true
            }
        },
        data: function () {
            return {
                currentStep: 1,
                room: null,
                matches: collect(),
            }
        },

        methods: {
            checkCode() {
                if (! this.code) {
                    return;
                }

                api.findGame(this.code).then((response) => {
                    this.room = response.data.data
                    this.matches = collect(this.room.childQuizess)
                    this.currentStep = 2
                }).catch( (error) => {

                    if (error.response.status === 403) {
                        this.currentStep = 4
                        return
                    }

                    this.$refs.alertModal.open()
                })
            },
        },

        computed: {
            ...mapState('websocket', [
                'isConnected',
            ]),
        },

        created() {
            this.checkCode()

            Quiz.$on('knockout-game-started', () => {
                this.currentStep = 3
            })

            Quiz.$on('spectator', (message) => {
                if (! this.matches.first(item => item.id === message.data.info.quiz.id)) {
                    this.matches.push(message.data.info.quiz)
                } else {
                    this.matches.transform((item) => {
                        if (item.id === message.data.info.quiz.id) {
                            item.status = message.data.info.quiz.status
                            item.quizUsers = message.data.info.quiz.quizUsers
                        }

                        return item
                    })
                }
            })

            Quiz.$on('game-finished', () => {
                api.findGame(this.code).then((response) => {
                    this.room = response.data.data
                    this.matches = collect(this.room.childQuizess)
                    this.currentStep = 2
                }).catch( (error) => {
                    console.log(error)
                    this.$refs.alertModal.open()
                })
            })
        },

        beforeDestroy() {
            if (this.room) {
                this.unsubscribe('knockout-' + this.room.id)
            }
            Quiz.$off('spectator')
            Quiz.$off('game-finished')
            Quiz.$off('scholar-game-restart')
            Quiz.$off('knockout-game-started')
            Quiz.$off('next-round-started')
        }
    }
</script>
